import React from 'react';
import * as Yup from 'yup';

import ModalForm from 'Components/Admin/Form/components/ModalForm/ModalForm';
import formatDataForSelect from 'Shared/util/formatDataForSelect';

const services = [
  { id: 1, title: 'IOS Development' },
  { id: 2, title: 'Web Development' },
];

const units = [
  { id: 1, title: 'hour' },
  { id: 2, title: 'month' },
];

const AssignmentForm = ({ history, closeUrl, mode }) => {
  const handleClose = () => history.push(closeUrl);

  const formItems = [
    {
      className: 'assignment-form__main',
      items: [
        {
          name: 'employeeName',
          type: 'text',
          label: 'Employee name',
          placeholder: 'Enter employee name',
          validation: Yup.string()
            .required('This field is required'),
        },
        {
          name: 'service',
          type: 'select',
          label: 'Service',
          placeholder: 'Select service',
          options: formatDataForSelect(services),
          validation: Yup.mixed()
            .required('This field is required'),
        },
        [
          {
            name: 'rate',
            type: 'currency',
            label: 'Rate',
            placeholder: 'Enter rate',
            currency: 'usd',
            validation: Yup.string()
              .required('This field is required'),
            rowClassName: 'assignment-form__rate-unit'
          },
          {
            name: 'unit',
            type: 'select',
            label: 'Unit',
            placeholder: 'Select unit',
            options: formatDataForSelect(units),
            validation: Yup.mixed()
              .required('This field is required'),
          },
        ],
      ],
    },
    {
      title: 'Assignment duration',
      items: [
        [
          {
            name: 'dateFrom',
            type: 'date',
            label: 'From',
            placeholder: 'Choose date',
            parentSelector: '.assignment-form__picker-renderer',
            rowClassName: 'assignment-form__picker-renderer',
            closeOnLeave: false,
            showNavbar: false,
            validation: Yup.mixed()
              .required('This field is required'),
          },
          {
            name: 'dateTo',
            type: 'date',
            label: 'To',
            placeholder: 'Choose date',
            parentSelector: '.assignment-form__picker-renderer',
            closeOnLeave: false,
            showNavbar: false,
            validation: Yup.mixed()
              .required('This field is required'),
          },
        ],
      ],
    },
    {
      title: 'Work schedule',
      className: 'assignment-form__schedule',
      items: [
        {
          name: 'schedule',
          type: 'schedule',
          days: [
            { label: 'Monday', name: 'monday' },
            { label: 'Tuesday', name: 'tuesday' },
            { label: 'Wednesday', name: 'wednesday' },
            { label: 'Thursday', name: 'thursday' },
            { label: 'Friday', name: 'friday' },
          ],
        },
      ],
    },
  ];

  const initialValues = {
    employeeName: '',
    service: null,
    rate: '',
    unit: null,
    dateFrom: '',
    dateTo: '',
    schedule: {
      monday: 5,
      wednesday: 5,
    },
  };

  const handleSubmit = (value) => {
    console.log(mode, value);
  };

  return (
    <ModalForm
      title="Assignment employee"
      className="assignment-form"
      testId={`${mode}-assignment-form`}
      onClose={handleClose}
      onSubmit={handleSubmit}
      formItems={formItems}
      initialValues={initialValues}
      isBlocks
    />
  );
};

export default AssignmentForm;
